/**
 * 油漆桶工具控制器（补齐 registry.ts 早先登记的占位工具）。
 *
 * 交互只有 down：点一下，app/paint-bucket-fill.ts 去泛洪+填色。
 * 泛洪是异步 wasm 调用，进行中忽略后续点击避免重入，跟魔棒/快速选择
 * 同一套纪律。
 */
import { paintBucketFill } from '../../app/paint-bucket-fill';
import type { AppStore } from '../../app/store';
import type { ToolManager } from './registry';

export interface PaintBucketDeps {
  readonly store: AppStore;
  readonly tools: ToolManager;
  readonly requestRender: () => void;
}

export class PaintBucketToolController {
  readonly #deps: PaintBucketDeps;
  #busy = false;

  constructor(deps: PaintBucketDeps) {
    this.#deps = deps;
  }

  handlePointer(phase: 'down' | 'move' | 'up' | 'double', point: { x: number; y: number }): boolean {
    const { store, tools } = this.#deps;
    if (tools.active.id !== 'paintBucket') return false;
    if (phase !== 'down') return true;
    if (store.document === null || this.#busy) return true;

    const tolerance = tools.getOption('paintBucket', 'tolerance') as number;
    const contiguous = tools.getOption('paintBucket', 'contiguous') as boolean;

    this.#busy = true;
    void paintBucketFill(store, point.x, point.y, store.foreground, { tolerance, contiguous })
      .catch((error: unknown) => {
        store.setHint(`油漆桶失败：${error instanceof Error ? error.message : String(error)}`);
      })
      .finally(() => {
        this.#busy = false;
        this.#deps.requestRender();
      });
    return true;
  }
}
